import React from 'react';
import cn from 'clsx';

import styles from './section.scss';

interface SectionProps {
  children?: React.ReactNode;
  className?: string;
  'data-testid'?: string;
  heading?: React.ReactNode;
  id?: string;
  intro?: React.ReactNode;
  isFullWidth?: boolean;
  showDivider?: boolean;
}

export const Section = React.forwardRef<HTMLElement, SectionProps>(
  function Section(props, ref) {
    const {
      children,
      className,
      'data-testid': dataTestId,
      heading,
      id,
      intro,
      isFullWidth = false,
      showDivider = false
    } = props;

    return (
      <section
        className={cn(
          showDivider ? styles['container-w-divider'] : styles['container'],
          `${className || ''} section`
        )}
        data-testid={dataTestId}
        id={id}
        ref={ref}
      >
        {heading && <h3 className={styles['heading']}>{heading}</h3>}
        {intro && <div className={styles['intro']}>{intro}</div>}
        <div
          className={cn(
            isFullWidth ? styles['content-fullwidth'] : styles['content'],
            'section__content'
          )}
          data-testid="section-content"
        >
          {children}
        </div>
      </section>
    );
  }
);

export default Section;
